<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-button type="primary" icon="plus" @click="addTemplate" style="width: 100%" >添加细类</el-button>
      </el-col>

    </el-row>


    <el-table :data="tagsList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="name" label="细类名称" width="200" >
        <template slot-scope="scope">
          {{scope.row.name}}
      </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="100">
        <template slot-scope="scope">
          {{scope.row.sort}}
        </template>

      </el-table-column>
      <el-table-column prop="cat_type" label="分类ID" width="200">
        <template slot-scope="scope">
          {{scope.row.cat_type}}

        </template>
      </el-table-column>
      <el-table-column prop="is_show" label="显示" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.is_show=='1'">显示</span>
          <span v-if="scope.row.is_show=='0'">不显示</span>
        </template>
      </el-table-column>

      <el-table-column prop="create_time" label="添加时间" width="200">
        <template slot-scope="scope">
          {{scope.row.create_time}}
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="operating-icons">
            <i class="iconfont icon-edit1" @click="editAction(scope.$index, scope.row)"></i>
<!--            <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i>-->
<!--            <el-button type="text" @click="onSale(scope.$index, scope.row)">上架</el-button>-->
<!--            <el-button type="text" @click="onSale(scope.$index, scope.row)" >下架</el-button>-->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="total_count > params.pageSize" class="content-center content-top-padded">
     <el-pagination
     layout="prev, pager, next"
     @current-change="handleCurrentChange"
     :current-page.sync="params.page"
     :total="total_count" :page-size="params.pageSize">
     </el-pagination>
   </div>
   <el-dialog title="添加、编辑标签" width="40%" :visible.sync="memberTagDialog" :before-close="handleCancelLabelsDialog">
     <template>
       <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">
         <el-form-item class="content-left" label="细类名称">
           <el-input placeholder="细类名称" v-model="form.name"></el-input>
         </el-form-item>
         <el-form-item class="content-left" label="排序">
           <el-input placeholder="数值越小排名越前" v-model="form.sort"></el-input>
         </el-form-item>
         <el-form-item class="content-left" label="分类ID">
           <el-input placeholder="1钱,2优惠券,3实物" v-model="form.cat_type"></el-input>
         </el-form-item>
         <el-form-item class="content-left" label="显示">
           <template>
             <el-radio-group v-model="form.is_show" @change="type_change">
             <el-radio-button  label="1">显示</el-radio-button>
             <el-radio-button  label="0">不显示</el-radio-button>
             </el-radio-group>
           </template>
         </el-form-item>

         <el-form-item class="content-center">
           <el-button type="primary" @click="saveTagData">确定保存</el-button>
         </el-form-item>
       </el-form>
     </template>
   </el-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { delItems,onSale,getCategoryList,createCategory,updateCategory, } from'../../../api/duiba.js'
  import {getUploadQiniuPicToken, uploadQiniuPic} from "../../../api/qiniu";
  // import {onSale,downSale} from "../../../api/baoxian";
  export default {
    data () {
      return {

        isEdit: false,
        tagsList: [],
        cateGoryList:[],
        loading: false,
        total_count: 0,
        actionPath: 'https://up-z1.qiniup.com',
        image_prefix: '',
        type_detail_list:[{
          type_name:'',id:''
        }],
        category_id:'',
        detail_type:'',
        postData: {
          token: '',
          key: '',
          fname: ''
        },
        pics:'',
        tag: [
          {label: '普药', value: 0},
          {label: '慢病', value: 1},
          {label: '慢病+', value: 2},
          {label: '肿瘤', value: 3}
        ]
      ,
        params: {
          page: 1,
          pageSize: 20,
          product_name: '',
        },
        form: {
          tag_id: '',
          product_name: '',
          tag_color: '#ff1939',
          font_color: '#ffffff',
          description: '',
          front_show: '0',
          is_pay: '1',
          type:1,
          intro:'',
          is_online:1,
          exchange_count:'',

        },

        memberTagDialog: false,
        predefineColors:['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585']
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
     type_change(e){

       this.radio = e;
       if (this.radio == "1") {

       } else if (this.radio=='2') {

       }else{

       }
     },



      handleCurrentChange (page_num) {
        this.params.page = page_num

        this.getDataList()
      },
      addTemplate () { // 添加商品
        this.memberTagDialog = true
        this.form = {id: '',product_name: '',tag: ''}
      },
      editAction (index, row) { // 编辑商品弹框
        this.form = row
        this.memberTagDialog = true
      },
      upAction (index, row) { // 编辑商品弹框
        this.form = row
        this.memberTagDialog = true
      },
      downAction (index, row) { // 编辑商品弹框
        this.form = row
        this.memberTagDialog = true
      },
      preview (index, row) { // 预览弹框
        this.dialogVisible = true
        this.dataInfo = row
      },
      searchData () {
        this.params.page = 1
        this.getDataList()
      },
      getDataList () {
        this.loading = true
        getCategoryList(this.params).then(response => {
          this.tagsList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
      getCategoryList(){
        this.loading = true
        getCategoryList(this.params).then(response => {
          this.cateGoryList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
          this.category_id=this.cateGoryList[0]
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },

      deleteAction (index, row) {

        this.$confirm('此操作将删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          delItems(row.id).then(response => {

            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 5 * 1000
            })
            this.getDataList()
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '删除失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      getTaskTime (strDate) {
          let date = new Date(strDate)
          let y = date.getFullYear()
          let m = date.getMonth() + 1
          m = m < 10 ? ('0' + m) : m
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          let str = y+"-"+m+"-"+d
          return str
      },
      getTimeStr (date) {
        return this.getTaskTime(new Date(parseInt(date) * 1000))
      },
      handleCancelLabelsDialog () {
  			this.memberTagDialog = false
      },
      saveTagData () {
        this.memberTagDialog = false
      //  this.form.pics= this.pics

    //    console.log(this.form);
        if (this.form.id!='') {

          updateCategory(this.form.id, this.form).then(res => {

            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '修改成功'
              })
              this.getDataList()
            }
          })
        } else {
          this.form.pics= this.pics
          createCategory(this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.getDataList()
            }
          })
        }
      },

    },

    mounted () {

      this.getDataList()
    this.getCategoryList()

// this.category_id= this.cateGoryList[0].id;
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// category.vue?2c096423